module.exports = __webpack_public_path__ + "static/media/classes.32596b73.png";